import {Icon, Typography, useBreakpointUp} from '@bonprix/design-system';
import {ActiveUnderlineWrapper} from './ActiveUnderlineWrapper.jsx';
import Device from '@core/scripts/components/device';
import Landmark from '@core/scripts/components/landmark-adapter';
import {useContext, useRef} from 'react';
import NavigationLayerHidden from './NavigationLayerHidden.jsx';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';
import {NavigationFocusContext} from '@header/scripts/components/context/NavigationFocusContext.jsx';
import {getOnlyDirectSubshop} from '@header/scripts/helper/sub-navigation-helper.js';

export default function NavigationItem({
    navigationItem,
    setCurrentHoveredItemId,
    currentHoveredItemId,
    isShopActive,
    delayedExecution,
}) {
    const {headerLightMode} = useContext(HeaderContext);
    const {toSecondLevel} = useContext(NavigationFocusContext);
    const isXlUp = useBreakpointUp('xl');
    const isXxlUp = useBreakpointUp('xxl');
    const isXlarge = isXlUp && !isXxlUp;

    const isTouchDevice = useRef(Device.isTouch() || matchMedia('(hover: none)').matches);
    const hasOverlayNavigation = !getOnlyDirectSubshop(navigationItem);

    const handleHoverIn = () => {
        if (!hasOverlayNavigation) {
            return;
        }

        delayedExecution(() => {
            setCurrentHoveredItemId(navigationItem.id);
        });
    };

    const handleHoverOut = () => {
        if (!hasOverlayNavigation) {
            return;
        }

        delayedExecution(() => {
            setCurrentHoveredItemId(undefined);
        });
    };

    const handleClick = (e) => {
        if (isTouchDevice.current) {
            e.preventDefault();
            setCurrentHoveredItemId(navigationItem.id);
        } else {
            const naviLmValue = `hn\\${navigationItem.id}\\`;
            Landmark.sendUserInterfaceLandmark({navi: naviLmValue});
        }
    };

    const handleArrowClick = (e) => {
        if (!hasOverlayNavigation) {
            return;
        }

        e.preventDefault();
        if (currentHoveredItemId) {
            setCurrentHoveredItemId(undefined);
        } else {
            toSecondLevel(e.currentTarget);
            setCurrentHoveredItemId(navigationItem.id);
        }
    };

    const itemColor = headerLightMode ? 'on-primary-high' : 'primary';
    const renderButHide = hasOverlayNavigation && !currentHoveredItemId && navigationItem.active;
    const directLinkClass = !hasOverlayNavigation ? 'navigation__item--direct-link' : '';
    return (
        <li
            onMouseEnter={handleHoverIn}
            onPointerLeave={handleHoverOut}
            className={`navigation__item -level:first ${directLinkClass}`}
            data-navigation-item-id={navigationItem.id}
        >
            <div className="flex flex-col w-full static">
                <a href={navigationItem.url} className={'navigation__item-label -level:first'} onClick={handleClick}>
                    <ActiveUnderlineWrapper
                        navigationItem={navigationItem}
                        currentHoveredItemId={currentHoveredItemId}
                        isShopActive={isShopActive}
                        lightMode={headerLightMode}
                    >
                        <Typography color={itemColor} variant={isXlarge ? 'bonprix-h6' : 'bonprix-h5'} component={'span'}>
                            {navigationItem.title}
                        </Typography>
                    </ActiveUnderlineWrapper>
                </a>

                {hasOverlayNavigation && (
                    <button
                        className="navigation__open-button"
                        onClick={handleArrowClick}
                        aria-label={`${navigationItem.title}, Unterkategorien anzeigen`}
                        aria-haspopup="true"
                        aria-expanded={!!currentHoveredItemId}
                        aria-controls="desktop-navigation-layer"
                    >
                        <Icon variant={'arrow-down'} className={'icon'} />
                    </button>
                )}
            </div>

            {renderButHide && <NavigationLayerHidden secondLevelNavigationItems={navigationItem.subNavigationItems} />}
        </li>
    );
}
